import React from 'react';
import IconExcited from '../../assets/icons/icon-excited.png';

// static asset imports
import IconFacebook from '../../assets/icons/icon-facebook.svg?react';
import IconInstagram from '../../assets/icons/icon-instagram.svg?react';
import IconTiktok from '../../assets/icons/icon-tiktok.svg?react';
import IconYoutube from '../../assets/icons/icon-youtube.svg?react';
import IconPinterest from '../../assets/icons/icon-pinterest.svg?react';
import Logo from '../../assets/icons/logo.svg?react';

const PopupSuccess = ({ color, logo, onClose }) => {
  return (
    <div className="feedback-form__success">
      <img className="feedback-form__success--main-icon" src={IconExcited} alt="Icon description" width="120" height="120" />
      <h4 className="feedback-form__success--title">Thank You for Your Valuable Feedback!</h4>
      <button className="feedback-form__success--btn" onClick={onClose} >CONTINUE READING</button>
      <p className="feedback-form__success--text">FOLLOW US</p>

      <div className="feedback-form__success--social">
        <ul>
          <li>
            <a href="https://www.facebook.com/prontofulfillment">
              <IconFacebook className="social-icon" style={{ fill: color }}/>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/pronto.fulfillment/#">
              <IconInstagram className="social-icon" style={{ fill: color }}/>
            </a>
          </li>
          <li>
            <a href="https://www.tiktok.com/@pronto_fulfillment">
              <IconTiktok className="social-icon" style={{ fill: color }}/>
            </a>
          </li>
          <li>
            <a href="https://www.pinterest.com/prontofulfillment/">
              <IconPinterest className="social-icon" style={{ fill: color }}/>
            </a>
          </li>
        </ul>
      </div>

      <Logo className="feedback-form__success--logo" />
    </div>
  );
};

export default PopupSuccess;
